import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {},
}));

/**
 *
 * @param {import("@material-ui/core").ButtonProps} props
 */
function BlueButton(props) {
  const classes = useStyles();
  const { children, ...restProps } = props;
  return (
    <Button
      fullWidth
      className={classes.root}
      variant="contained"
      size="large"
      color="secondary"
      {...restProps}
    >
      {children}
    </Button>
  );
}

export default BlueButton;
